// The Inverite instructions point at VoPay's own API endpoint, which differs between the sandbox and
// production portals (the same VITE_APP_ENV that picks the portal's backend)
export const IS_SANDBOX_ENVIRONMENT = import.meta.env.VITE_APP_ENV !== 'production';

export const VOPAY_API_ENDPOINT_URL = IS_SANDBOX_ENVIRONMENT
  ? 'https://earthnode-dev.vopay.com/api/v2'
  : 'https://earthnode.vopay.com/api/v2';
